import { render, staticRenderFns } from "./DealHot.vue?vue&type=template&id=0f36e9ec&"
import script from "./DealHot.vue?vue&type=script&lang=js&"
export * from "./DealHot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports